import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class BilSharedService {
  private selectedBank: any;
  constructor(private http: HttpClient) { }

  getDocDetails() {
    return this.http.get(environment.basePath + '/getDocDetails');
  }
  getStatus() {
    return this.http.get(environment.basePath + '/bs/status/v1');
    // return this.http.get('http://172.16.3.138:9080/bil/bs/status/v4');
  }

  public getSelectedBank() {
    return this.selectedBank;
  }

  public setSelectedBank(bank) {
    this.selectedBank = bank;
  }

  public addPartner(data){
    return this.http.post(environment.basePath + '/kyc/create', data);
  }
}
